<template>
  <div ref="wrapper" class="sw-wrapper" :class="{'sw-wrapper--flex': inline}">
    <div
      class="sw-wrapper__label"
      :class="{'sw-wrapper__label--centered': centered}"
      v-if="label && !inline"
      :style="`color: ${labelColor}`"
    >{{ label }}</div>
    <div
      ref="button"
      class="sw-button"
      @click="onClick"
      :class="[(on || alwaysActive) ? 'sw-button--active onBg' : '']"
      :style="contStyle"
    >
      <div ref="main" class="sw-button__main">
        <div ref="text" class="sw-button__text">{{text}}</div>
        <div ref="switch" class="sw-button__switch" :style="swStyle"></div>
      </div>
    </div>
    <div class="sw-wrapper__label sw-wrapper__label--right" v-if="label && inline">{{ label }}</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      on: true,
      text: '',

      // anim
      data: {
        anim: false,
        intervalId: null,
        i: null
      },
      maxWidth: 0,
      setWidth: 0
    }
  },
  props: {
    onText: String,
    offText: String,
    value: Boolean,
    inline: Boolean,
    label: String,
    swStyle: Object,
    contStyle: Object,
    alwaysActive: Boolean,
    centered: Boolean,
    fill: Boolean,
    width: Number,
    labelColor: {
      type: String,
      default: "#d55252"
    },
    inactive: Boolean
  },
  watch: {
    text: {
      immediate: true,
      handler: function () {
        setTimeout(() => {
          if (this.width) return
          if (this.$refs.text.clientWidth > this.maxWidth) {
            this.maxWidth = this.$refs.text.clientWidth
          }
          this.setWidth++
          if (this.setWidth === 1) {
            if (!this.on) this.text = this.onText
            else this.text = this.offText
          } else if (this.setWidth === 2) {
            if (this.on) this.text = this.onText
            else this.text = this.offText
          } else if (this.setWidth === 3) {
            this.$refs.text.style.width = this.maxWidth + 6 + 'px'
          }
        }, 0)
      }
    },

    value: function () {
      let wrapperDiv = this.$refs.wrapper

      this.on = this.value
      let textDiv = this.$refs.text
      let switchDiv = this.$refs.switch
      if (this.on) {
        textDiv.style.order = 0
        switchDiv.style.order = 1
      } else {
        textDiv.style.order = 1
        switchDiv.style.order = 0
      }
      if (this.on) this.text = this.onText
      else this.text = this.offText

    }
  },
  mounted() {
    this.on = this.value
    let textDiv = this.$refs.text
    let switchDiv = this.$refs.switch
    if (this.on) {
      textDiv.style.order = 0
      switchDiv.style.order = 1
    } else {
      textDiv.style.order = 1
      switchDiv.style.order = 0
    }

    if (this.on) this.text = this.onText
    else this.text = this.offText

    setTimeout(() => {
      this.$refs.text.style.width = this.width - this.$refs.switch.clientWidth + 'px'
    }, 0)
  },
  methods: {
    onClick() {
      if (this.data.anim || this.inactive) return

      this.on = !this.on
      if (this.on) this.text = this.onText
      else this.text = this.offText

      if (this.on) {
        this.$refs.text.style.order = 0
        this.$refs.switch.style.order = 1
      } else {
        this.$refs.text.style.order = 1
        this.$refs.switch.style.order = 0
      }

      this.data.anim = true
      this.startAnim()
      this.$emit('input', this.on)
    },

    startAnim() {
      let mn = this.$refs.main
      let sw = this.$refs.switch
      let text = this.$refs.text

      let mnWidth = mn.clientWidth // button + text width
      mn.style.width = mnWidth + 'px' // set fixed as we text will be hidden and we would lose original main width
      let widthForAnim = mnWidth - sw.clientWidth

      let howManyFrames = widthForAnim / 2
      let keyFrameDiff = widthForAnim / howManyFrames

      text.hidden = true
      if (!this.on) sw.style.marginLeft = widthForAnim + 'px'

      let i = 0
      let that = this
      this.data.intervalId = setInterval(function () {
        if (i > howManyFrames) {
          clearInterval(that.data.intervalId)
          sw.style.marginLeft = '0px'
          sw.style.marginRight = '0px'
          text.hidden = false
          that.data.anim = false
          mn.width = 'auto'
        } else {
          if (that.on) sw.style.marginLeft = keyFrameDiff * i + 'px'
          else if (!that.on && i < howManyFrames) sw.style.marginLeft = parseInt(sw.style.marginLeft, 10) - keyFrameDiff + 'px'
          i++
        }
      }, 6)
    }
  }

}
</script>

<style lang="scss" scoped>
.sw-button {
  cursor: pointer;
  background: #cccccc;
  position: relative;
  z-index: 100;
  padding: 2px;
  font-size: 0.8em;
  border-radius: 50px;
  height: 22px;
  display: flex;
  float: left;

  &__main {
    display: flex;
    align-items: center;
    flex-grow: 0;
  }

  &__text {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    color: white;
    font-family: Work Sans;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 0.85em;
    min-width: 18px;
  }

  &__switch {
    width: 22px;
    height: 22px;
    background-color: white;
    border-radius: 50%;
  }

  &--active {
    background-color: $primary
  }
  /*   &__first {
    margin-right: 0.3em;
  } */
}

.sw-button:before {
  background-color: $primary;
  border-radius: inherit;
  content: "";
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  z-index: -100;
  //transition: opacity 1.0s;
}

.onBg {
  &:before {
    opacity: 1;
  }
}

.sw-wrapper {
  display: inline-block;

  &--flex {
    @include alignedFlex(flex-start);
    .sw-wrapper__label {
      margin-right: 5px;
    }
  }

  &__label {
    @include labelStyle();
    position: relative;

    &--centered {
      text-align: center;
    }

    &--right {
      margin-left: 10px;
      margin-top: 3px;
    }
  }
}
</style>